// IFRS 18 and Cash Flow Fixes Card V2 · Part A (A2 discontinued operations, A4 IFRS 18 categories, A5 other comprehensive
// income, A6 / A7 new notes, A9 first year of IFRS 18) — EN + AR. Merged into lib/i18n.js translations (big-file rule: new
// strings in their own file).
export const I18N_IFRS18_A = {
  en: {
    ifrs: {
      validation: { groups: { pl: "Profit or loss and comprehensive income" } },
      a18: {
        cat: { operating: "Operating", investing: "Investing", financing: "Financing", income_taxes: "Income taxes",
               discontinued: "Discontinued operations" },
        plTitleOciIas1: "Statement of Profit or Loss and Other Comprehensive Income",
        plTitleOciIfrs18: "Statement of Profit or Loss and Other Comprehensive Income (IFRS 18 categorised)",
        continuing: "Profit from continuing operations",
        discontinued: "Profit / (loss) from discontinued operations",
        discontinuedOfWhich: "of which: {title}",
        beforeFinTax: "Profit before financing and income taxes",
        oci: "Other comprehensive income",
        ociNetOfTax: "Each item is shown net of its own tax.",
        ociTotal: "Other comprehensive income for the year",
        tci: "Total comprehensive income for the year",
        firstYear: {
          label: "First year of IFRS 18",
          help: "Tick when this is the first year the entity presents under IFRS 18. The notes then show the prior-year statement of profit or loss under IFRS 18 next to the same year under IAS 1, re-presented from the current mapping.",
          rolesOnly: "Only a Partner or a manager-level member (Audit Manager, Manager, Senior Manager, Assistant Manager, Reviewer, Supervisor) can change this.",
          saved: "First year of IFRS 18: saved",
          saveFailed: "Could not save the first-year setting",
        },
        transition: {
          line: "Line",
          ias1: "As presented under IAS 1",
          ifrs18: "Under IFRS 18",
          amount: "Prior year",
          subtotal: "Subtotal",
          ias1Col: "IAS 1",
          ifrs18Col: "IFRS 18",
          difference: "Difference",
          notApplicable: "n/a",
        },
      },
    },
    w13: { action: { ifrs18_first_year_set: "First year of IFRS 18 changed" } },
  },
  ar: {
    ifrs: {
      validation: { groups: { pl: "الربح أو الخسارة والدخل الشامل" } },
      a18: {
        cat: { operating: "التشغيلية", investing: "الاستثمارية", financing: "التمويلية", income_taxes: "ضرائب الدخل",
               discontinued: "العمليات المتوقفة" },
        plTitleOciIas1: "قائمة الربح أو الخسارة والدخل الشامل الآخر",
        plTitleOciIfrs18: "قائمة الربح أو الخسارة والدخل الشامل الآخر (مصنَّفة وفق IFRS 18)",
        continuing: "الربح من العمليات المستمرة",
        discontinued: "الربح / (الخسارة) من العمليات المتوقفة",
        discontinuedOfWhich: "منها: {title}",
        beforeFinTax: "الربح قبل التمويل وضرائب الدخل",
        oci: "الدخل الشامل الآخر",
        ociNetOfTax: "يُعرض كل بند بعد خصم الضريبة المتعلقة به.",
        ociTotal: "الدخل الشامل الآخر للسنة",
        tci: "إجمالي الدخل الشامل للسنة",
        firstYear: {
          label: "السنة الأولى لتطبيق IFRS 18",
          help: "حدِّد هذا الخيار إذا كانت هذه أول سنة تعرض فيها المنشأة قوائمها وفق IFRS 18. تعرض الإيضاحات عندئذٍ قائمة الربح أو الخسارة للسنة السابقة وفق IFRS 18 بجانب السنة نفسها وفق IAS 1 معادًا عرضها وفق التبويب الحالي.",
          rolesOnly: "لا يغيّر هذا الخيار إلا الشريك أو عضو بمستوى مدير (مدير المراجعة أو المدير أو المدير الأول أو مساعد المدير أو المراجع أو المشرف).",
          saved: "السنة الأولى لتطبيق IFRS 18: تم الحفظ",
          saveFailed: "تعذّر حفظ إعداد السنة الأولى",
        },
        transition: {
          line: "البند",
          ias1: "كما عُرض وفق IAS 1",
          ifrs18: "وفق IFRS 18",
          amount: "السنة السابقة",
          subtotal: "المجموع الفرعي",
          ias1Col: "IAS 1",
          ifrs18Col: "IFRS 18",
          difference: "الفرق",
          notApplicable: "لا ينطبق",
        },
      },
    },
    w13: { action: { ifrs18_first_year_set: "تغيير السنة الأولى لتطبيق IFRS 18" } },
  },
};

export default I18N_IFRS18_A;
